"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_i18next_1 = require("react-i18next");
var i18n_1 = __importDefault(require("@/react-app/i18n"));
var DecisionButtonAndDropdown_1 = __importDefault(require("@/react-app/common/components/DecisionButtonAndDropdown"));
function DecisionButton(_a) {
    var refusalReasons = _a.refusalReasons, onSelectDecision = _a.onSelectDecision, selectedDecision = _a.selectedDecision, isSearchPage = _a.isSearchPage, isDisabled = _a.isDisabled, queues = _a.queues, enableKeyboardShortcuts = _a.enableKeyboardShortcuts, isPostReviewed = _a.isPostReviewed, changeFocusedElement = _a.changeFocusedElement;
    var t = (0, react_i18next_1.useTranslation)().t;
    var selectedDecisionKey = (selectedDecision === null || selectedDecision === void 0 ? void 0 : selectedDecision.type) === 'refuse' ? selectedDecision.refuseDecisionKey : selectedDecision === null || selectedDecision === void 0 ? void 0 : selectedDecision.type;
    var _b = __read(react_1.default.useState(false), 2), isApproveBtnSelected = _b[0], setIsApproveBtnSelected = _b[1];
    var getText = function (decisionType, refuseReasonName) {
        if (decisionType === 'refuse') {
            return i18n_1.default.t('SEARCH.HEADER.DECISION_TEXT_REFUSE', { REFUSE_REASON: refuseReasonName });
        }
        if (decisionType === 'defer') {
            return i18n_1.default.t('SEARCH.HEADER.DECISION_TEXT_DEFER');
        }
        return i18n_1.default.t('SEARCH.HEADER.DECISION_TEXT_APPROVE');
    };
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            if (enableKeyboardShortcuts && document.activeElement === document.body) {
                if (event.key === 'a') {
                    approve();
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    });
    var refuse = function (refuseDecisionKey, reason) {
        onSelectDecision({ type: 'refuse', reason: reason, refuseDecisionKey: refuseDecisionKey }, getText('refuse', reason.name));
    };
    var approve = function () {
        onSelectDecision({ type: 'approve' }, getText('approve'));
    };
    var defer = function (queue) {
        onSelectDecision({ type: 'defer', queue: queue }, getText('defer'));
    };
    return (react_1.default.createElement("div", { className: "eva-job-decision-buttons ".concat(isSearchPage && 'eva-mass-action-decision') },
        react_1.default.createElement("button", { type: "button", className: (0, clsx_1.default)('btn dropdown-toggle btn-approve eva-decision-button eva-keyboard-focusable', { selected: selectedDecisionKey === 'approve' }, { 'is-disabled': isDisabled }, { 'eva-keyboard-focused': isApproveBtnSelected }), onClick: approve, "data-cy": !isSearchPage ? 'item-detail-approve-button' : undefined, onFocus: function () { return setIsApproveBtnSelected(true); }, onBlur: function () { return setIsApproveBtnSelected(false); } },
            !isSearchPage && react_1.default.createElement("span", { className: "eva-shortcut-icon" }, "A"),
            react_1.default.createElement("span", null, t('SEARCH.HEADER.APPROVE_BUTTON'))),
        refusalReasons.map(function (decision, index) { return (react_1.default.createElement(DecisionButtonAndDropdown_1.default, { key: index, decisionOptions: decision.values, isSelected: selectedDecisionKey === decision.key, decisionLabel: decision.key, onChange: function (valueItem) { return refuse(decision.key, valueItem); }, isDisabled: isDisabled, className: "refuse eva-keyboard-focusable", dropdownTitle: t('ITEM.REFUSE_BUTTON_DROP_DOWN_TITLE'), isSearchPage: isSearchPage, dataCy: "item-detail-refuse-button", enableKeyboardShortcuts: enableKeyboardShortcuts, shortcut: index === 0 ? 'R' : undefined, changeFocusedElement: changeFocusedElement })); }),
        queues && !isPostReviewed && (react_1.default.createElement(DecisionButtonAndDropdown_1.default, { queueOptions: queues, isSelected: selectedDecisionKey === 'defer', decisionLabel: t('ITEM.SEND_TO_QUEUE_BUTTON'), onChange: function (valueItem) { return defer(valueItem); }, isDisabled: isDisabled, className: "escalate eva-keyboard-focusable", dropdownTitle: t('ITEM.SEND_TO_QUEUE_DROP_DOWN_TITLE'), isSearchPage: false, dataCy: "item-detail-send-to-queue-button", enableKeyboardShortcuts: enableKeyboardShortcuts, shortcut: "S", changeFocusedElement: changeFocusedElement }))));
}
exports.default = DecisionButton;
